export function normalizeMarkdownContent(content: string): string {
  if (!content) {
    return '';
  }

  return content
    .replace(/\r\n/g, '\n')
    .replace(/\\r\\n/g, '\n')
    .replace(/\\n/g, '\n')
    .trim();
}
